import React, { useState } from "react";
import FadeInSectionDownToUp from "../FadeAnimations/FadeInSectionDownToUp";
import { CountryCode } from "../../components/Contact/CountryCode";
import axios from "axios";

export default function TrainingForm({ open, onClose }) {
  const [name, setName] = useState("");
  const [countrycode, setCountrycode] = useState("");
  const [number, setNumber] = useState("");
  const [mail, setMail] = useState("");
  const [qualification, setQualification] = useState("");
  const [state, setState] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [lookingfor, setLookingfor] = useState("");
  const [message, setMessage] = useState("");
  const [consent, setConsent] = useState(false);

  if (!open) return null; // don't render if modal is closed

  const addData = async () => {
    const requiredFields = [
      name,
      number,
      countrycode,
      mail,
      qualification,
      state,
      zipcode,
      lookingfor,
    ];
    const hasEmptyFields = requiredFields.some((field) => field === "");

    if (hasEmptyFields) {
      alert("Please fill in all required fields.");
      return;
    }

    if (!consent) {
      alert("Please authorize MH Cockpit to contact you.");
      return;
    }

    try {
      const newData = {
        Name: name,
        Country_code: countrycode,
        Mobile_Number: number,
        Email: mail,
        Qualification: qualification,
        State: state,
        Zip_code: zipcode,
        Looking_For: lookingfor,
        Message_Box: message,
        Consent: consent ? "Yes" : "No",
      };
      await axios.post("https://sheetdb.io/api/v1/5elucfkippn6o", newData);

      // Reset form
      setName("");
      setCountrycode("");
      setNumber("");
      setMail("");
      setQualification("");
      setState("");
      setZipcode("");
      setLookingfor("");
      setMessage("");
      setConsent(false);

      alert("Your form has been submitted successfully!");
      onClose();
    } catch (error) {
      console.error("Error in Submission", error);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl p-6 relative">
        {/* Close button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 text-black hover:text-black text-xl"
        >
          ✕
        </button>

        <FadeInSectionDownToUp>
          {/* Form Fields */}
          <div className="py-3">
            <input
              type="text"
              placeholder="Name"
              className="w-full px-3 py-2 rounded-md border text-black"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>

          <div className="flex space-x-3 py-3">
            <select
              className="w-1/4 rounded-md py-2 text-center border"
              value={countrycode}
              onChange={(e) => setCountrycode(e.target.value)}
            >
              {CountryCode.map((code) => (
                <option
                  key={code.value}
                  value={code.value}
                  disabled={code.disabled}
                  hidden={code.hidden}
                >
                  {code.value || code.text}
                </option>
              ))}
            </select>
            <input
              type="number"
              placeholder="Mobile Number"
              className="w-full px-3 py-2 rounded-md border"
              value={number}
              onChange={(e) => setNumber(e.target.value)}
            />
          </div>

          <div className="py-3">
            <input
              type="text"
              placeholder="Email ID"
              className="w-full px-3 py-2 rounded-md border"
              value={mail}
              onChange={(e) => setMail(e.target.value)}
            />
          </div>

          <div className="py-3">
            <input
              type="text"
              placeholder="Qualification"
              className="w-full px-3 py-2 rounded-md border"
              value={qualification}
              onChange={(e) => setQualification(e.target.value)}
            />
          </div>

          <div className="py-3">
            <input
              type="text"
              placeholder="State"
              className="w-full px-3 py-2 rounded-md border"
              value={state}
              onChange={(e) => setState(e.target.value)}
            />
          </div>

          <div className="py-3">
            <input
              type="text"
              placeholder="Zip Code"
              className="w-full px-3 py-2 rounded-md border"
              value={zipcode}
              onChange={(e) => setZipcode(e.target.value)}
            />
          </div>

          <div className="py-3">
            <select
              className="w-full rounded-md py-2 px-3 border text-black"
              value={lookingfor}
              onChange={(e) => setLookingfor(e.target.value)}
            >
              <option value="" disabled hidden>
                Looking For
              </option>
              <option>Commercial Pilot License</option>
              <option>Private Pilot License</option>
              <option>Airline Transport Pilot License</option>
              <option>Type Rating</option>
              {/* <option>DGCA Ground Class</option>
              <option>BBA Aviation Management</option>
              <option>BSc. Aviation</option>
              <option>B.Sc. Aeronautical Science</option>
              <option>BSc. Aircraft Maintenance Science</option>
              <option>BBA Logistics & Supply Chain Management</option>
              <option>MBA Aviation Management</option>
              <option>MBA Logistics & Supply Chain Management</option>
              <option>MBA HR Marketing and Finance</option>
              <option>Agriculture Drones</option>
              <option>DGCA License Conversion</option>
              <option>Cabin Crew Training</option> */}
            </select>
          </div>

          <div className="py-3">
            <input
              type="text"
              placeholder="Message Box (optional)"
              className="w-full px-3 py-2 rounded-md border"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </div>

          <div className="py-3 flex items-start">
            <input
              type="checkbox"
              id="consent"
              className="mt-1 mr-2"
              checked={consent}
              onChange={(e) => setConsent(e.target.checked)}
            />
            <label htmlFor="consent" className="text-sm text-gray-700">
              I authorize <strong>4 Aviators</strong> to contact me with updates
              and notifications via Email, SMS, WhatsApp, and Call. This will
              override the registry on DND / NDNC.
            </label>
          </div>

          <center className="py-3">
            <button
              onClick={addData}
              className="bg-blue-600 text-white hover:bg-blue-700 transition duration-500 ease-in-out shadow-lg py-2 px-8 rounded-md"
            >
              Submit
            </button>
          </center>
        </FadeInSectionDownToUp>
      </div>
    </div>
  );
}
